<template>
    <div>
        <MainHeader />
        <div class="page">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-7">
                        <div style="padding:20px;margin:40px 20px;background-color:#f6f6f6;border:1px solid #ccc;">
                            <h2 style="margin:0px 0px 20px 0px;">Registration</h2>
                                
                                <div v-if="result">
                                    {{result}}
                                </div>
                                <div v-else>

                                <form>
                                  <div class="form-group">
                                    <input v-model="other" type="text" name="other" id="other" ref="other" style="position:absolute;top:-1000px">
                                    <label for="email">Email Address (Required)</label>
                                    <input v-model="email" ref="email" type="email" class="form-control" id="email" placeholder="">

                                    
                                    
                                  </div>
                                  <div class="form-group">
                                    <label for="name">Name (Appreciated)</label>
                                    <input  v-model="name" type="name" ref="name" class="form-control" id="name" placeholder="">
                                  </div>
                                  <hr/>
                                  <div class="form-group">
                                    <label for="exampleInputPassword1">Sometimes we release updates with new features, datasets, or factsheets. Can we send you an e-mail (one per month at most) when there have been updates to the website that we'd like to share?</label>
                                    <div class="custom-control custom-radio custom-control-inline">
                                      <input v-model="newsletter" type="radio" id="newsletter-yes" name="newsletter" value="newsletter-yes" class="custom-control-input">
                                      <label class="custom-control-label" for="newsletter-yes" >Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                      <input v-model="newsletter" type="radio" id="newsletter-no" name="newsletter" value="newsletter-no" class="custom-control-input">
                                      <label class="custom-control-label" for="newsletter-no">No</label>
                                    </div>
                                  </div>
                                  <hr/>
                                  <div class="form-group">
                                    <label for="terms">Do you agree to our <a href="/terms" target="_blank">terms of service</a>? It says things like that we can disable your account if you abuse the service, and that you don't hold us accountable if something breaks or is inaccurate.</label>

                                    <div class="custom-control custom-radio custom-control-inline">
                                      <input v-model="terms" type="radio" id="terms-yes" name="terms" value="terms-yes" class="custom-control-input">
                                      <label class="custom-control-label" for="terms-yes" >Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                      <input v-model="terms" type="radio" id="terms-no" name="terms" value="terms-no" class="custom-control-input">
                                      <label class="custom-control-label" for="terms-no">No</label>
                                    </div>
                                  </div>
                                  <hr/>

                                <p v-if="error" style="margin-bottom:10px;" class="is-invalid">{{ error }}</p>
                                <button type="submit" @click.prevent="register" ref="register" class="btn btn-lg btn-primary" :disabled="disabled"><strong>Register</strong></button>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  
  export default {
      data() {
        return {
          error: null,
          result: null,
          email: '',
          name: '',
          terms: "terms-yes",
          newsletter: "newsletter-yes",
          other: '',
          disabled: false
        }
      },
      mounted() {
        this.$refs["email"].focus()
      },
      computed: {
        emailOk() {
            return String(this.email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        },
        termsOk() {
            return (this.terms == 'terms-yes')
        },
        formOk() {
            return (this.emailOk && this.termsOk)
        }
      },
    methods: {
      register() {
        this.$refs["register"].blur();
        this.disabled = true;
        if(!this.termsOk) {
            this.error = "You must agree to the terms of service to create an account."
            return
        }
        if(!this.emailOk) {
            this.error = "Please enter a valid e-mail address to create an account."
            return
        }
        if(this.other) {
            this.error = "Something went wrong with the form. Contact info@geofolio.org for more information."
            return
        }
        const params = {
           'email': this.email,
           'name': this.name,
           'newsletter': this.newsletter,
           'terms': this.terms,
           'other': this.other
        }
        const headers = {
            'X-CSRFTOKEN': this.csrfcookie()
        }
        this.$axios
           .post(process.env.VUE_APP_API+"/api/register", params, { headers: headers })
           .then(response => {
                this.result = response.data.message
                this.disabled = false;
           })
           .catch(error => {
                this.result = "An unexpected error occurred while processing your request. Contact info@geofolio.org for more information."
                this.disabled = false;
           })
      }
    },
    name: 'register',
    components: {
      MainHeader, Footer
    }
  }
</script>

<style scoped>

div.page {
    font-size:1.1em;
    color:#666;
}
h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}
p {
    line-height:1.4em;
}

.is-invalid {
    color: #dc3545;
}
label.is-invalid {
    font-weight:bold;
}
</style>